import { createContext } from 'react';

import { RouterProviderProps } from './RouterProvider.tsx';

export const RouterContext = createContext<RouterProviderProps | undefined>(undefined);
